import { DownloadOutlined } from '@ant-design/icons';
import { Button, Dropdown, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { exportRows, type ExportColumn } from '../utils/export';

/** Excel or CSV export of a list as filtered on screen (FR-CON-17). */
export function ExportButton<T>({
  fileName,
  columns,
  rows,
}: {
  fileName: string;
  columns: ExportColumn<T>[];
  rows: T[];
}) {
  const { t } = useTranslation();
  return (
    <Dropdown
      trigger={['click']}
      disabled={rows.length === 0}
      menu={{
        items: [
          { key: 'xlsx', label: t('export.excel') },
          { key: 'csv', label: t('export.csv') },
        ],
        onClick: ({ key }) => void exportRows(fileName, columns, rows, key as 'xlsx' | 'csv'),
      }}
    >
      <Tooltip title={t('export.title')}>
        <Button
          icon={<DownloadOutlined />}
          aria-label={t('export.title')}
          disabled={rows.length === 0}
        />
      </Tooltip>
    </Dropdown>
  );
}
